import React, { useCallback, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import SmartscriptModal from "components/Smartscript/SmartscriptModal";
import useAuthentication from "hooks/useAuthentication";

import SearchEntityModal from "./SearchEntityModal";

const SmartScriptButton = ({
  className,
  entity,
}: {
  className?: string;
  entity?: any;
}) => {
  const { account } = useAuthentication();
  const [showSearchEntityModal, setShowSearchEntityModal] = useState(false);
  const [showSmartscriptModal, setShowSmartscriptModal] = useState(false);
  const [transcriptId, setTranscriptId] = useState<string | number>();
  const [loading, setLoading] = useState<boolean>(false);

  const onGenerateStart = useCallback(() => {
    setLoading(true);
    setTranscriptId(undefined);
    setShowSearchEntityModal(false);
    setShowSmartscriptModal(true);
  }, []);

  const onGenerated = useCallback((id?: string | number) => {
    setTranscriptId(id);
    setLoading(false);
  }, []);

  const onGenerateError = useCallback(() => {
    setShowSmartscriptModal(false);
    setLoading(false);
  }, []);

  if (!account?.canRequestAIPrimer) return null;

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip>
            <p className="mb-0">
              Generate Synthetic Expert Call Transcripts using Smartkarma AI
            </p>
          </Tooltip>
        }
      >
        <span
          className={twMerge(
            "inline-flex items-center justify-center",
            "cursor-pointer",
            "text-[18px]",
            "hover:bg-[rgba(204,204,204,0.6)] px-[20px] py-[10px] rounded-full",
            className
          )}
          onClick={() => setShowSearchEntityModal(true)}
        >
          <span>+ SmartScript</span>
        </span>
      </OverlayTrigger>

      {/* Mounted only while open, so every field resets on close and on generate. */}
      {showSearchEntityModal && (
        <SearchEntityModal
          loading={loading}
          onClose={() => setShowSearchEntityModal(false)}
          onGenerateStart={onGenerateStart}
          entity={entity}
          onGenerated={onGenerated}
          onGenerateError={onGenerateError}
        />
      )}

      <SmartscriptModal
        isOpen={showSmartscriptModal}
        onClose={() => setShowSmartscriptModal(false)}
        transcriptId={transcriptId}
        loading={loading}
      />
    </>
  );
};

export default SmartScriptButton;
